export const DownloadIcon = "path://M6 21H18M12 3V17M12 17L17 12M12 17L7 12"
